/**
 * @file        src/components/FaviconManager.jsx
 * @description Applies the favicon configured in admin Site Settings (per-brand
 *              brands.favicon_url) across the site. Renders nothing; on mount
 *              (and whenever the configured URL changes) it points the
 *              document's <link rel="icon"> (and the Apple touch icon) at the
 *              uploaded favicon. When none is configured it leaves the static
 *              default in index.html (/logo.png) untouched. Ported from the
 *              neon build — Beyond previously had no favicon manager at all,
 *              so an admin-uploaded favicon never took effect here.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (ported from neon, unchanged).
 */
import { useEffect } from 'react';
import { useCompanyInfo } from '../hooks/useCompanyInfo.js';

export default function FaviconManager() {
  const { faviconUrl } = useCompanyInfo();

  useEffect(() => {
    if (!faviconUrl) return;
    const ensure = (rel) => {
      let link = document.head.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      return link;
    };
    ensure('icon').href = faviconUrl;
    ensure('apple-touch-icon').href = faviconUrl;
  }, [faviconUrl]);

  return null;
}
